import { render, staticRenderFns } from "./PaybackReasonsList.vue?vue&type=template&id=4ba0b210"
import script from "./PaybackReasonsList.vue?vue&type=script&lang=js"
export * from "./PaybackReasonsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports